module.exports = __webpack_public_path__ + "img/event.2f976496.jpg";